<template>
  <div class="centerPage">
    <div class="pageTit">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/drug/list' }">药物管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ !drugId ? '新增' : '编辑' }}药物</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-form ref="form" class="article_edit" label-width="120px">
      <el-form-item label="中文名：">
        <el-input v-model="drugData.cnName" placeholder="请输入中文名">
        </el-input>
      </el-form-item>
      <el-form-item label="英文名：">
        <el-input v-model="drugData.enName" placeholder="请输入英文名">
        </el-input>
      </el-form-item>
      <el-form-item label="状态：">
        <el-radio-group v-model="drugData.status" class="type">
          <el-radio :label="1">展示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否为新药：">
        <el-radio-group v-model="drugData.drugType" class="type">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="缩略图：">
        <el-upload
            v-if="drugData.thumbnailPath"
            :limit="1"
            :action="uploadUrl"
            name="uploadFile"
            list-type="picture-card"
            class="uploadImg"
            :on-success="handleImageSuccess">
          <div v-if="imageUrl">只能上传一张图
          </div>
          <div v-else class="maxHeight">
            <div v-if="imageUrl"></div>
            <div v-else :style="'backgroundImage: url('+drugData.thumbnailPath+')'" class="img"></div>
          </div>
        </el-upload>
        <el-upload
            v-else
            :limit="1"
            :action="uploadUrl"
            name="uploadFile"
            list-type="picture-card"
            class="uploadImg"
            :on-success="handleImageSuccess">
          <span slot="default">点击上传</span>
        </el-upload>
      </el-form-item>

      <el-form-item label="简述：">
        <el-input v-model="drugData.briefDesc" placeholder="请输入简述"
                  :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
        </el-input>
      </el-form-item>
      <el-form-item label="剂量：">
        <el-input v-model="drugData.dose" placeholder="请输入剂量"
                  :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
        </el-input>
      </el-form-item>
      <el-form-item label="黑盒警告：">
        <el-input v-model="drugData.blackBoxWarn" placeholder="请输入黑盒警告"
                  :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
        </el-input>
      </el-form-item>
      <el-form-item label="禁忌：">
        <el-input v-model="drugData.taboo" placeholder="请输入禁忌"
                  :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
        </el-input>
      </el-form-item>
      <el-form-item label="副作用：">
        <el-input v-model="drugData.sideEffect" placeholder="请输入副作用"
                  :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
        </el-input>
      </el-form-item>
      <el-form-item label="药物原理：">
        <el-input v-model="drugData.principle" placeholder="请输入药物原理"
                  :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
        </el-input>
      </el-form-item>
      <el-form-item label="药物相互作用：">
        <el-input v-model="drugData.drugInteractions" placeholder="请输入药物相互作用"
                  :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
        </el-input>
      </el-form-item>
      <el-form-item label="孕期注意事项：">
        <el-input v-model="drugData.pregnancyAttention" placeholder="请输入孕期注意事项"
                  :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
        </el-input>
      </el-form-item>
      <el-form-item label="备注：">
        <el-input v-model="drugData.remark" placeholder="请输入备注"
                  :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
        </el-input>
      </el-form-item>
      <el-form-item label="适应症：">
        <el-checkbox-group v-model="drugData.indicationIds"
                           @change="handleCheckedChange"
                           class="handleCheckedChange">
          <el-checkbox v-for="(item,ind) in allIndicationData" :label="item.id" :key="ind">
            {{ item.cnName }}
          </el-checkbox>
        </el-checkbox-group>
        <el-button class="selectAll" size="small" plain>
          <el-checkbox :indeterminate="isIndeterminate"
                       v-model="checkAll"
                       @change="handleCheckAllChange">
            全选适应症
          </el-checkbox>
        </el-button>
      </el-form-item>
      <el-form-item label="药物类别：">
        <el-checkbox-group v-model="drugData.categoryIds" @change="handleCheckedChangeCate" class="handleCheckedChange">
          <el-checkbox v-for="(item,ind) in allDrugCategoryData" :label="item.id" :key="ind">
            {{ item.cnName }}
          </el-checkbox>
        </el-checkbox-group>
        <el-button class="selectAll" size="small" plain>
          <el-checkbox :indeterminate="drugIsIndeterminate" v-model="drugCheckAll" @change="handleCheckAllChangeCate">
            全选药物类别
          </el-checkbox>
        </el-button>
      </el-form-item>
      <div class="btn">
        <el-button @click="saveUpdateDrugMethod">{{ drugId ? '更新' : '添加' }}</el-button>
      </div>
    </el-form>


  </div>
</template>

<script>
import commonjs from "../../../api/common";

export default {
  name: "drug_detail",
  data() {
    return {
      drugData: {
        id: '',
        cnName: '',
        enName: '',
        status: '',
        drugType: '',
        thumbnailPath: '',
        briefDesc: '',
        dose: '',
        blackBoxWarn: '',
        taboo: '',
        sideEffect: '',
        principle: '',
        drugInteractions: '',
        pregnancyAttention: '',
        remark: '',
        indicationIds: [],
        categoryIds: [],
      },//药物数据

      allIndicationData: {},//所有服务类型
      allIndicationId: [],//所有服务类型的id
      checkAll: false,//服务类型-全选
      isIndeterminate: true,//服务类型-全选

      allDrugCategoryData: {},//所有药物类型
      allDrugCategoryId: [],//所有服务类型的id
      drugCheckAll: false,//药物类型-全选
      drugIsIndeterminate: true,//药物类型-全选

      drugId: this.$route.query.id,//药物id

      imageUrl: '',// 新增上传组件显示上传的图片
      uploadUrl: commonjs.uploadUrl + "drug" || ' ',


    }
  },
  mounted() {
    this.getAllIndication();
    this.getAllDrugCategory();
    if (this.drugId != null) {//如果有id,则查询药物
      this.getDrugMethod();
    }
  },
  methods: {
    //获得药物信息
    getDrugMethod() {
      let that = this;
      this.$ajax
          .post(commonjs.api.drug.edit.detail.replace("{id}", this.drugId))
          .then(function (res) {
            if (res.data.status === 'success') {
              that.drugData.cnName = res.data.data.drugDetail.cnName;
              that.drugData.enName = res.data.data.drugDetail.enName;
              that.drugData.status = res.data.data.drugDetail.status;
              that.drugData.thumbnailPath = res.data.data.drugDetail.thumbnailPath;
              that.drugData.briefDesc = res.data.data.drugDetail.briefDesc;
              that.drugData.dose = res.data.data.drugDetail.dose;
              that.drugData.blackBoxWarn = res.data.data.drugDetail.blackBoxWarn;
              that.drugData.taboo = res.data.data.drugDetail.taboo;
              that.drugData.sideEffect = res.data.data.drugDetail.sideEffect;
              that.drugData.principle = res.data.data.drugDetail.principle;
              that.drugData.drugInteractions = res.data.data.drugDetail.drugInteractions;
              that.drugData.pregnancyAttention = res.data.data.drugDetail.pregnancyAttention;
              that.drugData.remark = res.data.data.drugDetail.remark;
              let categoryData = [];
              if (res.data.data.category != null) {
                $(res.data.data.category).each((index, obj) => {
                  categoryData.push(obj.categoryId);
                })
                that.drugData.categoryIds = categoryData;
              }
              let indicationData = [];
              if (res.data.data.indication) {
                $(res.data.data.indication).each((index, obj) => {
                  indicationData.push(obj.indicationId);
                })
                that.drugData.indicationIds = indicationData;
              }
            }
          })
    },
    //更新药物
    saveUpdateDrugMethod() {
      let that = this;
      that.drugData.id = this.drugId;
      this.$ajax
          .post(commonjs.api.drug.edit.saveUpdate.replace("{type}", (this.drugId ? 1 : 0)), this.drugData)
          .then(function (res) {
            if (res.data.status === 'success') {
              that.$message({
                message: res.data.message,
                type: 'success'
              })
              that.$router.push({name: 'drugList'});
            } else {
              that.$message.error(res.data.message)
            }
          }).catch((err) => {
        console.error(err);
        that.$message.error('操作失败')
      })
    },
    //服务类型-全选
    handleCheckAllChange(val) {
      this.drugData.indicationIds = val ? this.allIndicationId : [];
      this.isIndeterminate = false;
    },
    //服务类型-选择
    handleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.allIndicationId.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.allIndicationId.length;
    },
    //药物类型-全选
    handleCheckAllChangeCate(val) {
      this.drugData.categoryIds = val ? this.allDrugCategoryId : [];
      this.drugIsIndeterminate = false;
    },
    //药物类型-选择
    handleCheckedChangeCate(value) {
      let checkedCount = value.length;
      this.drugCheckAll = checkedCount === this.allDrugCategoryId.length;
      this.drugIsIndeterminate = checkedCount > 0 && checkedCount < this.allDrugCategoryId.length;
    },
    //获得所有服务类型
    getAllIndication() {
      let vm = this;
      this.$ajax
          .get(commonjs.api.famousDoctor.indication)
          .then(function (res) {
            if (res.data.status === 'success') {
              vm.allIndicationData = res.data.list;
            }
          });
      this.$ajax
          .get(commonjs.api.doctor.allIndicationId)
          .then(function (res) {
            if (res.data.status === 'success') {
              vm.allIndicationId = res.data.list;
            }
          })
    },
    //获得所有药物类型
    getAllDrugCategory() {
      let vm = this;
      this.$ajax
          .get(commonjs.api.drug.category.simple_all)
          .then(function (res) {
            if (res.data.status === 'success') {
              vm.allDrugCategoryData = res.data.list;
              $(res.data.list).each((i, o) => {
                vm.allDrugCategoryId.push(o.id);
              })
            }
          })
    },
    //上传图片
    handleImageSuccess(res, file) {// 新增上传组件
      this.imageUrl = URL.createObjectURL(file.raw);
      this.drugData.thumbnailPath = res.message;
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/banner.scss';

.centerPage {
  display: block;
  width: auto;

  ::v-deep .el-form-item {
    display: block;
    .el-form-item__label {
      width: auto;
    }
  }

  ::v-deep .el-form-item__content {
    width: 80%;

    .el-checkbox {
      min-width: 12%;
      height: 27px;
      line-height: 27px;
      font-size: 13px;
      color: #999999;

      ::v-deep .el-checkbox__inner {
        width: 13px;
        height: 13px;
        border: 1px solid #999999;
        border-radius: 2px;
      }
    }

    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #567BFF;
      border-color: #567BFF;
    }

    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #999999;
    }
  }
}

.ql-snow .ql-color-picker, .ql-snow .ql-picker.ql-header {
  line-height: 24px;
}
</style>